/* template */
<template><div class="mpx-root-view"><div class="skeleton-container" v-if="(showSkeleton)"><div :style="[({background: '#fff', marginBottom: '10px'})] | transRpxStyle"><es-navbar :style="[(navbarStyle)] | transRpxStyle" :left-arrow="(true)" @click-left="goBackReport" :onClickLeft="(homeBack)"><div v-if="(isScramble)">备选车次</div><div class="es-navbar-title" v-else-if="(!fromChangeTicket)"><mpx-view @tap="reverseCity" class="es-navbar-title-text">{{ title[0] }}<div class="title-switch-icon"></div>{{ title[1] }}</mpx-view></div><change-navbar :process="(0)" v-else/></es-navbar><div :style="[({paddingBottom: '0.5px'})] | transRpxStyle"><es-date ref="__mpx_ref_es_date__" :value="(time)" :date-type="('MM-dd')" checkType="single" :linking="(linking)" :isUpdateEveryTime="(true)" :checkRange="(14)" :maxDate="(maxDateTime)" :minDate="(minDateTime)" :maxHeaderDate="(headerMaxDateTime)" :minHeaderDate="(headerMinDateTime)" startText="去程" endText="返程" title="选择前往日期" :closeable="(true)" :isRequest="(pageLoading)" @confirm="onConfirm" @handleClickDay="handleClickDay" v-if="(!isScramble)"/></div></div><div class="skeleton"><div v-for="(item, index) in (10)" class="skeleton-item"><div class="skeleton-item-1"/><div class="skeleton-item-2"/><div class="skeleton-item-3"/><div class="skeleton-item-4"/><div class="skeleton-item-5"/><div class="skeleton-item-6"/></div></div></div><es-over-layout :custom-class="(isScramble ? 'list-custom-class-scramble' : 'list-custom-class')" :layout="(['header', 'footer'])" :esMainStyle="(esMainStyle)" :useDefaultNavbar="(false)" :useBlankPage="(useBlankPage)" :blankImageUrl="(blankImageUrl)" :blankContextTitle="(blankContextTitle)" :blankContextSubTitle="(blankContextSubTitle)" :hasBlankButton="(hasButton)" blankPageType="blank-page" @blank-retry="clickButton" v-else><div slot="header" class="list-header"><es-navbar :style="[(navbarStyle)] | transRpxStyle" :left-arrow="(true)" @click-left="goBackReport" :onClickLeft="(homeBack)"><div v-if="(isScramble)">备选车次</div><div class="es-navbar-title" v-else-if="(!fromChangeTicket)"><mpx-view @tap="reverseCity" class="es-navbar-title-text">{{ title[0] }}<div class="title-switch-icon"></div>{{ title[1] }}</mpx-view></div><change-navbar :process="(0)" v-else/></es-navbar><es-date ref="__mpx_ref_es_date__" :value="(time)" :date-type="('MM-dd')" checkType="single" :linking="(linking)" :isUpdateEveryTime="(true)" :checkRange="(14)" :maxDate="(maxDateTime)" :minDate="(minDateTime)" :maxHeaderDate="(headerMaxDateTime)" :minHeaderDate="(headerMinDateTime)" startText="去程" endText="返程" title="选择前往日期" :closeable="(true)" @confirm="onConfirm" @handleClickDay="handleClickDay" v-if="(!isScramble)"/><div class="notice-tips" v-if="(serviceNoticeList && serviceNoticeList.length && !isScramble)"><notice-tip v-for="(item, index) in (serviceNoticeList)" :key="item.index" :titleText="(item.title)" @click="showTipsPop(index)"/></div><div class="use-blankp-page-tab" v-if="(!fromChangeTicket && !isScramble && useBlankPage && !isAliAndNotLogin)"><div class="header-item-wrapper"><Tab :tabKey="(unionType)" :tabList="(tabList)" @settabkey="setUnionType"/></div><top-condition-bar :unionType="(unionType)" :trainListSearchQuery="(trainListSearchQuery)" @parentDataChange="updateData" @getTrainListFunc="getTrainListFunc(false)"/><div class="coupon-banner" v-if="(!isScramble && !isAliAndNotLogin && useBlankPage)"><coupon-banner-simplify :isShowNoticeTip="(!!serviceNoticeList.length)"/></div><airflow-train-guide-card :trackType="(airflowTrainGuideCardInfo.type)" type="flight" :cardIcon="(airflowTrainGuideCardInfo.icon)" :iconDesc="(airflowTrainGuideCardInfo.title)" :departureStation="(airflowTrainGuideCardInfo.dep_city_name)" :arrivalStation="(airflowTrainGuideCardInfo.arr_city_name)" :elapsedTime="(airflowTrainGuideCardInfo.travel_time)" :personalizedCopy="(airflowTrainGuideCardInfo.desc)" :ticketPrice="(airflowTrainGuideCardInfo.show_price/100)" @click="gotoFlightList" :extern-class='["airflow-train-guide-card-container"].join(" ")' v-if="(!isFromAirflowGuideCard && airflowTrainGuideCardInfo.title)"/></div><div class="black-page-line" v-if="(useBlankPage)"/><div v-if="(isScramble)"><train-list-condition-bar ref="__mpx_ref_conditionbar__" :trainListSearchQuery="(trainListSearchQuery)" :selectCityList="(selectCityList)" @parentDataChange="updateData" @getTrainListFunc="getTrainListFunc(false)" @reportClick="conditionBarClickReport" isScramble/></div></div><mpx-view :class="(isScramble && 'scrambling', showSkeleton && 'train-list-container-skeleton')" :style="[(isScramble ? 'paddingBottom: 0' : '')] | transRpxStyle" @scroll="handleScroll" class="train-list-container"><div class="header-item-wrapper tab" v-if="(!fromChangeTicket && !isScramble && !isAliAndNotLogin)"><Tab :tabKey="(unionType)" :tabList="(tabList)" @settabkey="setUnionType"/></div><div class="header-item-wrapper sticky" v-if="(!isScramble)"><top-condition-bar :unionType="(unionType)" :trainListSearchQuery="(trainListSearchQuery)" @parentDataChange="updateData" @getTrainListFunc="getTrainListFunc(false)"/></div><div class="header-item-wrapper coupon-banner" v-if="(!isScramble && !isAliAndNotLogin)"><coupon-banner-simplify :isShowNoticeTip="(!!serviceNoticeList.length)"/></div><div class="header-item-wrapper guide-tip" v-if="(showPreScrambleGuide)"><guide-tips/></div><union-login-card v-if="(showUnionLoginCard)"/><div class="item-container" v-else><airflow-train-guide-card :trackType="(airflowTrainGuideCardInfo.type)" type="flight" :cardIcon="(airflowTrainGuideCardInfo.icon)" :iconDesc="(airflowTrainGuideCardInfo.title)" :departureStation="(airflowTrainGuideCardInfo.dep_city_name)" :arrivalStation="(airflowTrainGuideCardInfo.arr_city_name)" :elapsedTime="(airflowTrainGuideCardInfo.travel_time)" :personalizedCopy="(airflowTrainGuideCardInfo.desc)" :ticketPrice="(airflowTrainGuideCardInfo.show_price/100)" @click="gotoFlightList" :extern-class='["airflow-train-guide-card-container"].join(" ")' v-if="(!isFromAirflowGuideCard && airflowTrainGuideCardInfo.title)"/><div v-for="(item, index) in (trainList)" :key="item.index" class="train-list-container-item"><train-info-card :trainInfo="(item)" :isScramble="(isScramble)" @goDetail="goDetail(item, index)" :fromChangeTicket="(fromChangeTicket)" :include="(scrambleInclude(item))" :current="(current)"/></div><Loading v-if="(pageNumber > 1 && pageLoading)"/></div></mpx-view><div :style='["width: 100%"] | transRpxStyle' slot="footer" v-if="(!isScramble)"><train-list-condition-bar ref="__mpx_ref_normalContionBar__" :trainListSearchQuery="(trainListSearchQuery)" :selectCityList="(selectCityList)" @parentDataChange="updateData" @getTrainListFunc="getTrainListFunc(false)" @reportClick="conditionBarClickReport" :unionType="(unionType)" :isScramble="(isScramble)"/></div><div slot="footer" class="footer-button-container" v-if="(isScramble)"><div slot="footer-tips" class="scramble-tips"><div class="scramble-tips-icon"></div>选择车次越多，抢票成功率越高</div><div class="footer-button"><es-button type="large" custom-class="card-button" @click="chooseScrambleTrains">确定</es-button></div></div></es-over-layout><notice-popup :show="(isShowNoticePopup)" :info="(notice)" @close="hideNoticePop"/><es-toast id="es-toast"/><es-dialog id="es-dialog"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m17bb021e"}'>
  @import '~@/mixins/stylus/color.styl'

  .list-custom-class
    // background-image url('https://dpubstatic.udache.com/static/dpubimg/4hnS2tq0TNoruy-zYTC4p.png')
    // background-repeat no-repeat
    // background-position center center
    // background-size cover
    // /deep/ .es-main
    //   background transparent
    background #fff
  .list-custom-class-scramble
    background #fff
  .list-header
    background #fff
  .es-navbar-title
    display flex
    justify-content center
    align-items center
    font-size 18px
    font-weight 400
    color #000004
    font-family PingFangSC-Medium
    &-text 
      display flex
      align-items center
  .title-switch-icon
    background url('https://dpubstatic.udache.com/static/dpubimg/jLtzjh7lf8gnyLQmazzrw.png')
    width 12px
    height 10px
    background-size cover
    margin 0 6px
  .es-navbar-right
    font-size 15px
    font-weight 600
    color $train-color-333
  .use-blankp-page-tab 
    .header-item-wrapper
      padding-bottom 12px
    .coupon-banner
      padding 0px 8px 0
      background #f2f6f9
  .train-list-container
    overflow auto
    box-sizing border-box
    padding 0
    position relative
    height 100%
    display flex
    flex-direction column
    .header-item-wrapper
      background #fff
      &.tab
        padding-bottom 12px
      &.sticky
        position sticky
        top 0
        z-index 3
      &.coupon-banner
        padding 0px 8px 0
        background #f2f6f9
      &.guide-tip
        padding 12px 8px 0
        background #f2f6f9
    &.scrambling
      padding-top 8px
      background #F2F6F9
    &-skeleton 
      overflow hidden
    .item-container
      background #f2f6f9
      padding 12px 8px 0 
      flex 1
  .train-list-container-item
    margin-bottom 8px
  .skeleton-container
    background #f0f1f4
  .skeleton
    // height 75%
    // width 96%
    // position absolute
    // top 135px
    // left 10px
    // overflow hidden
    height 100%
    width 100%
    &-item 
      margin 0 10px
      // width 100%
      height 101px
      background #FFFFFF
      border-radius 16px
      position relative
      margin-bottom 8px
      &-1
        position absolute 
        top 14px
        left 16px
        height 38.5px
        width 44px
        background #E4EAEF
        border-radius 5px
      &-2
        position absolute 
        top 18.5px
        left 120px
        height 11px
        width 41px
        background #E4EAEF
        border-radius 5px
      &-3
        position absolute 
        top 42.5px
        left 120px
        height 11px
        width 41px
        background #E4EAEF
        border-radius 5px
      &-4
        position absolute 
        top 14px
        left 221px
        height 38.5px
        width 44px
        background #E4EAEF
        border-radius 5px
      &-5
        position absolute 
        top 17px
        left 295px
        height 20px
        width 44px
        background #FF6400
        border-radius 5px
      &-6
        position absolute 
        top 76px
        left 16px
        height 11px
        width 90px
        background #E4EAEF
        border-radius 5px
  .black-page-line
    background #f2f6f9
    height 12px
    width 100%
  .notice-tips
    display flex
    flex-direction column
  .condition-bar-container
    position relative
  .scramble-tips
    width 100%
    height 40px
    background linear-gradient(0deg, #FFF6F1, #FFF6F1), linear-gradient(270deg, #FFFFFF 3%, #FFF3EB 100%)
    font-family PingFangSC-Regular
    font-size 12px
    color #333333
    line-height 40px
    display flex
    align-items center
    padding-left 19px
    &-icon 
      width 16px
      height 16px
      background url('https://dpubstatic.udache.com/static/dpubimg/TDO9qn7xSN5cWQg3Gi8cE.png')
      background-size cover
      margin-right 4px
  .footer-button-container
    width 100vw
    display flex
    flex-direction column
  .footer-button
    width 100vw
    height 98px
    padding 16px 16px 34px 16px !important
    background-color #ffffff
    box-sizing border-box
  .card-button
    font-size 16px
    font-weight bold
    text-align center
    color white
    border-width 0px
    border-radius 8px
    background-color #FF6400
  .airflow-train-guide-card-container
    background #FFFFFF
    border-radius 16px
    margin-bottom 8px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m17bb021e"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./list.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./list.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m17bb021e"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-toast':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/toast/index.mpx?isComponent&outputPath=components%2Findex68e47551%2Findex")),'guide-tips':getComponent(require("./components/guide-tips.mpx?isComponent&outputPath=components%2Fguide-tips99b597a0%2Findex")),'train-info-card':getComponent(require("./components/train-info-card.mpx?isComponent&outputPath=components%2Ftrain-info-card3ca59191%2Findex")),'id-authorize':getComponent(require("./components/id-authorize.mpx?isComponent&outputPath=components%2Fid-authorizec9661104%2Findex")),'union-login-card':getComponent(require("./components/union-login-card.mpx?isComponent&outputPath=components%2Funion-login-card576fe4f9%2Findex")),'train-list-condition-bar':getComponent(require("./components/train-list-condition-bar/index.mpx?isComponent&outputPath=components%2Findex54224a61%2Findex")),'top-condition-bar':getComponent(require("./components/top-condition-bar/index.mpx?isComponent&outputPath=components%2Findex25fa1e73%2Findex")),'Tab':getComponent(require("../../components/tab.mpx?isComponent&outputPath=components%2Ftab6186cc86%2Findex")),'Loading':getComponent(require("../../components/loading.mpx?isComponent&outputPath=components%2Floadingba41c4a6%2Findex")),'notice-tip':getComponent(require("../../material/block/notice/noticeTip.mpx?isComponent&outputPath=components%2FnoticeTip87cd944c%2Findex")),'notice-popup':getComponent(require("../../material/block/notice/noticePopup.mpx?isComponent&outputPath=components%2FnoticePopup9be6912a%2Findex")),'airflow-train-guide-card':getComponent(require("../../../node_modules/@didi/spring-ui/airflow-train-guide-card/index.mpx?isComponent&outputPath=components%2Findex172f639c%2Findex")),'travel-system-drawer':getComponent(require("../../components/travel-system-drawer/index.mpx?isComponent&outputPath=components%2Findexf17fe788%2Findex")),'change-navbar':getComponent(require("../../components/change-navbar/index.mpx?isComponent&outputPath=components%2Findex262f9081%2Findex")),'es-over-layout':getComponent(require("../../es-mpx-ui/lib/layout/index.mpx?isComponent&outputPath=components%2Findex2146c876%2Findex")),'coupon-banner-simplify':getComponent(require("../../components/coupon/coupon-banner-simplify/index.mpx?isComponent&outputPath=components%2Findex30f50040%2Findex")),'es-date':getComponent(require("../../material/element/calendar-date/index.mpx?isComponent&outputPath=components%2Findex549eb962%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
